import "../_styles/main.scss";
import { RouterProvider } from "react-router";
import { router } from "./router";

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
